import { Component, Input, OnInit } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-empty-list-info',
  templateUrl: './empty-list-info.component.html',
  styleUrls: ['./empty-list-info.component.scss'],
  imports: [MatIconModule],
})
export class EmptyListInfoComponent {
  @Input() text: string = '';
  constructor() {}
}
